import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/_auth/workspaces/')({
  validateSearch: z.object({
    next: z.string().optional().prefault(''),
  }),
  head() {
    return {
      meta: [
        {
          title: 'Workspaces | MINT',
        },
      ],
    };
  },
});
